var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 16.5H1.77273C0.793677 16.5 0 15.8284 0 15V4.5C0 3.67157 0.793677 3 1.77273 3H17.7273C18.7063 3 19.5 3.67157 19.5 4.5L19.5 7.5H22.2273C23.2063 7.5 24 8.25552 24 9.1875V19.3125C24 20.2445 23.2063 21 22.2273 21H6.27273C5.29368 21 4.5 20.2445 4.5 19.3125V16.5ZM6 7.2C5.00589 7.2 4.2 8.00589 4.2 9V14.7H1.8V4.8H17.7L17.7 7.2H6ZM14.25 17.25C15.9069 17.25 17.25 15.9069 17.25 14.25C17.25 12.5931 15.9069 11.25 14.25 11.25C12.5931 11.25 11.25 12.5931 11.25 14.25C11.25 15.9069 12.5931 17.25 14.25 17.25Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsActive);
export default __webpack_public_path__ + "static/media/payments-active.c59a397e57a3bc0c23ddd79be427b46c.svg";
export { ForwardRef as ReactComponent };